// Selection lists require completed supplier verification; saved document
// identities and historical records remain available independently.
export function verifiedSupplierChoices(contacts) {
  return (Array.isArray(contacts) ? contacts : []).filter(
    (contact) => contact?.contactVerifiedStatus === "Verified"
  );
}
